<template>
	<div>
		<div class="detail-bg">
			<van-row class="video-play-area">
				<van-col span="24">
					<div id="player" class="video-play-bg" :class="{'hide': (isBuy == false && isFree == false) || (isBuy == true && courseInfo.subsection == null)}"></div>
					<van-image class="course-banner" :class="{'show': (isBuy == false && isFree == false) || (isBuy == true && courseInfo.subsection == null)}" fit="cover" :src="imgUrl + courseInfo.course_banner_image" />   
				</van-col>
			</van-row>
			<van-row class="list-bg">
				<van-col span="24">
					<van-cell class="detail-list" title="目录" is-link :value="courseListCount" />
					<div class="list-container">
						<div class="list-item fix" :class="{'list-item-title-on': current == index}" v-for="(item, index) in courseInfo.subsection" :key="index" @click="playCourse(item),playStyle(index)">
							<div class="fl list-item-imgbox">
								<van-image class="list-item-img" fit="cover" :src="item.polyv_first_image" />
							</div>
							<div class="fl list-item-title">{{item.subsection_title}}</div>
						</div>
					</div>
				</van-col>
			</van-row>
			<div class="list-bg list-bg-margin lecturer-container-pad-b">
				<van-cell class="detail-list" title="讲师" />
				<div class="lectinfo-container" v-if="lecturer.length == 1" v-for="(item, index) in lecturer" :key="index">
					<div class="lectinfo-personalinfo">
						<van-image class="lectinfo-tx" fit="cover" :src="imgUrl+item.lecturer_image" />
						<div class="lectinfo-personalinfo-r">
							<div class="lectinfo-name">{{item.lecturer_name}}</div>
							<div class="lectinfo-title">{{item.lecturer_title}}</div>
						</div>
					</div>
					<!-- <van-col span="24" class="lectinfo-intro">{{item.lecturer_synopsis}}</van-col> -->
				</div>
				<!-- 多个讲师 10.8 -->
				<div class="lectinfo-container-more" v-if="lecturer.length > 1">
					<div class="lectinfo-container-more-item" v-for="(item, index) in lecturer" :key="index">
						<van-image class="lectinfo-tx" fit="cover" :src="imgUrl+item.lecturer_image" />
						<div class="lectinfo-personalinfo-r">
							<div class="lectinfo-name">{{item.lecturer_name}}</div>
							<div class="lectinfo-title">{{item.lecturer_title}}</div>
						</div>
					</div>
				</div>
			</div>
			<van-row class="list-bg list-bg-margin" :class="{'list-bg-bottom': isBuy == false}">
				<van-col span="24">
					<van-cell class="detail-list" title="课程简介" />
					<van-col span="24" class="detail-course-intro">
						<div v-html='courseInfo.course_content'></div>
					</van-col>
				</van-col>
			</van-row>
		</div>
		<van-row class="detail-statu" :class="{'hide': isBuy == true}">
			<van-col span="24">
				<van-row class="detail-statu-buy">
					<van-col span="24">
						<div class="detail-statu-price">¥{{courseInfo.course_price}}</div>
						<div class="detail-statu-btn">
							<!-- <van-button type="default" :disabled="disabled" @click="buyThis($event)">立即购买</van-button> -->
							<van-button type="default"  @click="showCoupons">立即购买</van-button>
						</div>
					</van-col>
				</van-row>
			</van-col>
		</van-row>
		<van-row class="buy-alert-container" v-if="isCoupons == true">
			<van-col span="24" class="classbuy-alert-infobox">
				<div class="fix buy-course-line">
					<div class="fl buy-course-leftmark">购买内容</div>
					<div class="fl buy-course-rightinfo">{{courseInfo.course_title}}</div>
				</div>
				<div class="fix buy-course-line">
					<div class="fl buy-course-leftmark">订单金额</div>
					<div class="fl buy-course-rightinfo">￥{{courseInfo.course_price}}</div>
				</div>
				<div class="buy-course-coupons" v-if="radios != null">有效优惠券</div>
				<div class="have-course-coupons-box">
					<div class="radio-box" v-if="radios != null" v-for="(item,index) in radios" :key="item.id">
						<span class="radio" :class="{'on':item.isChecked}"></span>
						<input v-model="payType" :value="item.coupon_par_value" :checked='item.isChecked' class="input-radio" @click="check(index)"
						 type="radio">{{item.coupon_name}}
					</div>
				</div>
				<div class="paidprice" v-if="radios != null">
					<div class="paidprice-text">实付款：</div>
					<div class="paidprice-num">¥{{afterPrice}}</div>
				</div>
				<div class="detail-statu-btn alert-bg-buy-btn">
					<van-button type="default" :disabled="disabled" @click="buyThis($event)">确定</van-button>
				</div>
				<van-image class="closeCoupons" fit="cover" src="../../../static/images/sahnchu.png" @click="closeCoupons" />
			</van-col>
		</van-row>
		<van-image class="toIndex" fit="cover" src="../../../static/images/toindex.png" @click="toIndex" />
	</div>
</template>


<script>
	import wxapi from '@/common/wxapi.js'
	export default{
		data(){
			return{
				imgUrl: 'http://sls.zhishen.net.cn', //图片拼接路径
				//imgUrl: 'http://bsd.mswcy.net',
				courseInfo: '',
				lecturer: [],
				courseTitile: '',
				courseImgurl: '',
				courseDesc: '',
				courseListCount: '',
				polyvVid: '',
				isFree: '',
				isBuy: '',
				onlyCode: '',
				current: 0,
				disabled: false,
				radios: [],
				isCoupons: false,
				salePrice: '', //优惠的价格
				afterPrice: '', //实付价格
				userCouponId: 0,  //用户使用的优惠券id
				userMobile: false  //用户是否绑定手机号
			}
		},
		created(){
			let that = this;
			//授权登录
			if(localStorage.getItem('userId') == null){
				localStorage.setItem('beforeUrl', location.href.split('&')[0])
				that.$router.push({path: '/author'})
			}
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('user_id', localStorage.getItem('userId'));
			formdata.append('token', localStorage.getItem('token'));
			formdata.append('course_id', location.href.split('&')[0].split('?')[1].split('=')[1]);
// 			formdata.append('user_id', 685);
// 			formdata.append('token', 'e8cc4453-6c35-40e6-ac7d-279c07bdb452');
// 			formdata.append('course_id', 2);
			that.$axios.post('http://sls.zhishen.net.cn/api/Course/getCourseDetails', formdata)
			.then(function (res) {
				that.isBuy = res.data.course_details.buy_status
				that.courseInfo = res.data.course_details
				that.onlyCode = res.data.course_details.course_code
				that.courseTitile = res.data.course_details.course_title
				that.courseImgurl = that.imgUrl + res.data.course_details.course_thumbnail_image
				that.courseDesc = res.data.course_details.course_synopsis
				that.lecturer = res.data.lecturer
				that.userMobile = res.data.user_mobile
				setTimeout(function(){
					document.title = that.courseTitile
				}, 100)
				if(res.data.course_details.subsection == null){
					that.courseListCount = '共0节'
				}else{
					that.polyvVid = res.data.course_details.subsection[0].polyv_vid; //初次进入页面，vid为目录第一节vid
					that.courseListCount = '共' + res.data.course_details.subsection.length + '节'
					that.player = polyvObject('#player').videoPlayer({
						'width': '100vw',
						'height': '56.27vw',
						'vid': that.polyvVid,
					});
					let interval = setInterval(that.render, 500);
				}
				// 分享去除微信默认参数
				if (/from=[^&$?]{1,}(&|$)/.test(location.search) || /isappinstalled=[^&$?]{1,}(&|$)/.test(location.search)) {
					let newSearch = location.search.replace(/from=[^&$?]{1,}(&|$)/, '').replace(/isappinstalled=[^&$?]{1,}(&|$)/, '').replace(/&$|\?$/, '');
					let newUrl = location.origin + location.pathname + newSearch + location.hash;
					location.replace(newUrl);
					let option = {
						title: that.courseTitile,
						link: newUrl,
						imgUrl: that.courseImgurl,
						desc: that.courseDesc
					}
					wxapi.wxRegister(option)
				}else{
					let option = {
						title: that.courseTitile,
						link: location.href.split('&')[0],
						imgUrl: that.courseImgurl,
						desc: that.courseDesc
					}
					wxapi.wxRegister(option)
				}
			})
		},
		methods: {
			//点击目录播放视频
			playCourse(vid){
				if(vid.is_free == 0 && this.isBuy == false){
					this.isFree = false
					this.$toast({duration: 1000,message: '请购买后观看'});
				}else{
					this.isFree = true
					this.player.changeVid({
						vid: vid.polyv_vid,
						autoplay: true
					})
					let interval = setInterval(this.render, 500);
				}
			},
			//点击视频添加高亮
			playStyle(index){
				this.current = index;
			},
			//点击立即购买弹出优惠信息
			showCoupons() {
				let that = this
				if(that.userMobile == true){
					that.isCoupons = true;
					let formdata = new FormData();
					formdata.append('user_id', localStorage.getItem('userId'));
					formdata.append('token', localStorage.getItem('token'));
					formdata.append('goods_type', 1);
					formdata.append('good_id', location.href.split('&')[0].split('?')[1].split('=')[1]);
					that.$axios.post('http://sls.zhishen.net.cn/api/Usercoupon/qualifiedCoupon', formdata)
					.then(function(res) {
						that.radios = res.data.coupon_list;
						if(that.radios == null){
							that.afterPrice = that.courseInfo.course_price
							that.userCouponId = 0
						}else{
							that.radios[0].isChecked = true;
							that.userCouponId = that.radios[0].id
							that.afterPrice = parseFloat((that.courseInfo.course_price - that.radios[0].coupon_par_value).toFixed(2));
							if (that.afterPrice < 0) {
								that.afterPrice = 0
							}
						}
					}).catch(function(error){
						console.log(error)
					})
				}else{
					window.location.href = that.login.pageUrl + '/bindphone?buyUrl='+location.href;
				}
			},
			//选择优惠券
			check(index) {
				var that = this
				//先取消所有选中项
				that.radios.forEach((item) => {
					item.isChecked = false;
				});
				//再设置当前点击项选中
				that.salePrice = that.radios[index].coupon_par_value;
				//用户当前选择的优惠券id
				that.userCouponId = that.radios[index].id
				// 设置值，以供传递
				that.radios[index].isChecked = true;
				//选中优惠券后计算减后价格
				that.afterPrice = parseFloat((that.courseInfo.course_price - that.salePrice).toFixed(2));
				if (that.afterPrice < 0) {
					that.afterPrice = 0
				}
			},
			//关闭优惠信息
			closeCoupons() {
				this.isCoupons = false;
			},
			//购买
			buyThis(){
				let that = this
				that.disabled = true
				let payData;
				let formdata = new FormData();
				let platform;
				if (window.location.href.indexOf('platform')) {
					platform = that.getUrlParam('platform')
				} else {
					platform = 1
				}
				formdata.append('user_id', localStorage.getItem('userId'));
				formdata.append('token', localStorage.getItem('token'));
				formdata.append('only_code', that.onlyCode);
				formdata.append('goods_type', 1);
				formdata.append('platform', platform);
				formdata.append('user_coupon_id', that.userCouponId)
				that.$axios.post('http://sls.zhishen.net.cn/api/Order/addOrder', formdata)
				.then(function (res) {
					if(res.data.code == 3){
						that.$toast({duration: 1000,message: '购买成功'})
						window.location.reload();
					}
					if(res.data.code == 1){
						payData = res.data.data
						function onBridgeReady(){
							WeixinJSBridge.invoke(
								'getBrandWCPayRequest', {
									"appId": payData.appId,     //公众号名称，由商户传入     
									"timeStamp": payData.timeStamp,         //时间戳，自1970年以来的秒数     
									"nonceStr": payData.nonceStr, //随机串     
									"package": payData.package,     
									"signType": payData.signType,         //微信签名方式：     
									"paySign": payData.paySign //微信签名 
								},
								function(res){
									if(res.err_msg == "get_brand_wcpay_request:ok" ){
										// 使用以上方式判断前端返回,微信团队郑重提示：
										//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
										//支付成功刷新页面数据
										window.location.reload();
										console.log('支付成功')
										that.disabled = false
									}else{
										console.log('支付失败')
										that.disabled = false
									}
								}
							); 
						}
						if (typeof WeixinJSBridge == "undefined"){
						   if( document.addEventListener ){
							   document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
						   }else if (document.attachEvent){
							   document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
							   document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
						   }
						}else{
						   onBridgeReady();
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			//回首页
			toIndex(){
				this.$router.push({path: '/'});
			},
			getUrlParam(name){ 
				var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)"); 
				var r = window.location.search.substr(1).match(reg); 
				if (r!=null) return unescape(r[2]); return null; 
			}
		}
	}
</script>

<style>
	@import url("../../assets/css/detail.css");
	.radio-box {
		display: inline-block;
		position: relative;
		width: 100%;
		height: 4.8vw;
		line-height: 4.8vw;
	}
	
	.input-radio {
		display: inline-block;
		position: absolute;
		opacity: 0;
		width: 4.8vw;
		height: 4.8vw;
		cursor: pointer;
		left: 0px;
		outline: none;
		-webkit-appearance: none;
	}
	
	.radio {
		display: inline-block;
		width: 4.8vw;
		height: 4.8vw;
		vertical-align: middle;
		cursor: pointer;
		background-image: url(../../../static/images/selected.png);
		background-repeat: no-repeat;
		background-size: 4vw 4vw;
	}
	
	.on {
		background-image: url(../../../static/images/selectedOn.png);
		background-size: 4vw 4vw;
	}
</style>



// WEBPACK FOOTER //
// src/view/live/detail.vue